export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
export const USERNAME_LOGIN_ERROR = 'USERNAME_LOGIN_ERROR';
export const PASSWORD_LOGIN_ERROR = 'PASSWORD_LOGIN_ERROR';
export const PHONE_LOGIN_ERROR = 'PHONE_LOGIN_ERROR';
export const SMS_LOGIN_ERROR = 'SMS_LOGIN_ERROR';